import { useCallback, useMemo } from 'react';
import {
  scrollToFirst as scrollToFirstUtil,
  scrollUp as scrollUpUtil,
  scrollDown as scrollDownUtil,
  scrollToLast as scrollToLastUtil,
} from './tabulatorScroll';

/**
 * List toolbar arrow handlers — scroll Tabulator (benchmark: mntn001).
 * @param {() => object|undefined|null} getTable
 * @returns {{ scrollToFirst: () => void, scrollUp: () => void, scrollDown: () => void, scrollToLast: () => void }}
 */
export function useTabulatorScrollArrows(getTable) {
  const scrollToFirst = useCallback(() => {
    scrollToFirstUtil(getTable());
  }, [getTable]);

  const scrollUp = useCallback(() => {
    scrollUpUtil(getTable());
  }, [getTable]);

  const scrollDown = useCallback(() => {
    scrollDownUtil(getTable());
  }, [getTable]);

  const scrollToLast = useCallback(() => {
    scrollToLastUtil(getTable());
  }, [getTable]);

  return useMemo(
    () => ({ scrollToFirst, scrollUp, scrollDown, scrollToLast }),
    [scrollToFirst, scrollUp, scrollDown, scrollToLast]
  );
}
